import PropTypes from 'prop-types';

import { ContextPanel } from 'Panels';

const Toast = ({ children, type, ...rest }) => (
  <ContextPanel className="relative pr-12" type={type} {...rest}>
    {children}
  </ContextPanel>
);

Toast.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([
    'danger',
    'info',
    'loading',
    'success',
    'warning',
    'working',
  ]).isRequired,
};

export default Toast;
